import * as packageJson from '../../package.json'

export const environment = {
    production: false,
    URL_BASE: 'https://partnerhub-api-stg.stone.com.br',
    AUTH_URL_BASE: 'https://stgapi.mundipagg.com/auth/v2',
    AUTH_CLIENT_WEBAPP: 'PartnersHub_WebApp',
    ID_URL_BASE: 'https://stgapi.mundipagg.com/id/v2',
    ID_URL_DOMAIN: 'https://stgapi.mundipagg.com',
    appVersion: packageJson.version,
    npsID: 'Vmfx7HNkGPs90itd',
    googleId: 'G-X4W4JDNB38',
    intercom_app_id: 'vrlq7jfh',
    amplitudeKey: '4986157931445e1c7fec50eda70bc270',
}
